module.exports = __webpack_public_path__ + "media/images/common/icon-arrow-right--beige-3992e88aec2343167e9d733342293412.png";